// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".IdCardButton_reset-list_YEjKX{margin:0;padding:0;list-style:none;display:block}.IdCardButton_uppercase-sm_3Kk9T{font-size:12px;text-transform:uppercase;letter-spacing:.03667em}.IdCardButton_icon_1NnJh{display:block;width:35px;height:auto;margin-right:8px}", ""]);
// Exports
exports.locals = {
	"reset-list": "IdCardButton_reset-list_YEjKX",
	"uppercase-sm": "IdCardButton_uppercase-sm_3Kk9T",
	"icon": "IdCardButton_icon_1NnJh"
};
module.exports = exports;
